// extracted by mini-css-extract-plugin
module.exports = {"green":"#29f085","black":"#1d252c","block":"VerifiedBadge_block__DOetC","tier":"VerifiedBadge_tier__ZW4rv"};